// Table of contents:
// 1 suppliers
// 2 supplier
// 3 roleAssignments
// 4 members
// 5 master data management
import { Selfservices } from '../../../data'
import { createMasterDataManagement } from './createMasterDataManagement'
import { createMembers } from './createMembers'
import { createRoleAssignments } from './createRoleAssignments'
import { createSupplier } from './createSupplier'
import { createSuppliers } from './createSuppliers'

export const createSelfservices = (): Selfservices => {
  return {
    // 1 suppliers
    suppliers: createSuppliers(),
    // 2 supplier
    supplier: createSupplier(),
    // 3 role assignments
    roleAssignments: createRoleAssignments(),
    // 4 members
    members: createMembers(),
    // 5 master data management
    masterDataManagement: createMasterDataManagement(),
  }
}
